import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useVendorStore from "components/core/HomePage/useVendorStore";
import { strings } from "utils/constants/strings";

function isNotFarmerOutlet(currentSellerDetail) {
  if (currentSellerDetail?.outlet_type == strings.farmerOutlet) {
    return false;
  }
  return true;
}

export default function useSellerContext() {
  const navigate = useNavigate();
  const outletId = window.localStorage.getItem("outlet_id");

  const sellerDetails = useVendorStore((state) => state.sellerDetails);
  const sellerProfile = useVendorStore((state) => state.sellerProfile);
  const getSellerDetails = useVendorStore((state) => state.getSellerDetails);
  const getSellerProfile = useVendorStore((state) => state.getSellerProfile);
  const fetchAppConfigs = useVendorStore((state) => state.fetchAppConfigs);

  const [showSubHeader, setShowSubHeader] = useState(false);
  const [currentSellerDetail, setCurrentSellerDetail] = useState({});
  const [allSellersDetails, setAllSellersDetails] = useState([]);

  useEffect(() => {
    getSellerDetails({
      phone_number: window.localStorage.getItem("phone_number"),
      check_for_dn_tncs: true,
    });
    getSellerProfile();
  }, []);

  useEffect(() => {
    if (sellerDetails?.seller_outlet_details?.length > 0) {
      setShowSubHeader(true);
      const allSellerOutletDetails = [...(sellerDetails?.seller_outlet_details || [])];
      const index = allSellerOutletDetails.findIndex((item) => item.outlet_id == outletId);

      setCurrentSellerDetail(
        index !== -1
          ? sellerDetails?.seller_outlet_details[index]
          : sellerDetails?.seller_outlet_details[0]
      );
      const currentOutlet = sellerDetails?.seller_outlet_details[index];
      if (index !== -1 && index !== 0) {
        const itemToMove = allSellerOutletDetails.splice(index, 1);
        const updatedSellerList = [...itemToMove, ...allSellerOutletDetails];
        setAllSellersDetails(updatedSellerList);
      } else {
        setAllSellersDetails(allSellerOutletDetails);
      }

      if (!isNotFarmerOutlet(currentOutlet)) {
        window.localStorage.setItem("seller-type", strings.farmerOutlet);
      } else {
        window.localStorage.removeItem("seller-type");
      }

      if (!window.localStorage.getItem("referrer_platform")?.length) {
        fetchAppConfigs({
          app_mode: strings.appModeSeller,
        });
      }
    }
  }, [sellerDetails]);

  const handleProfileNavigate = () => {
    navigate("/profile");
  };

  return {
    sellerDetails,
    sellerProfile,
    getSellerDetails,
    getSellerProfile,
    showSubHeader,
    currentSellerDetail,
    allSellersDetails,
    handleProfileNavigate,
  };
}
